export default __webpack_public_path__ + "static/media/businessCardsHero.79d0eb53.jpg";